import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class RecentSearchService {
  // private storageName: string = 'RecentSearchBox';
  constructor() {}

  getRecentSearches(storageName: string): any[] {
    if (localStorage.getItem('RecentSearchBox')) {
      localStorage.removeItem('RecentSearchBox');
      localStorage.removeItem('RecentSearchBox1');
    }
    return JSON.parse(localStorage.getItem(storageName) ||'[]');
  }
  saveRecentSearch(searchValue: string, storageName: string): void {
    let recentSearches = this.getRecentSearches(storageName);
    const isDuplicate = recentSearches.some((item) => item.value === searchValue);

    if (!isDuplicate) {
      recentSearches.unshift({ value: searchValue, url: searchValue });
      recentSearches = recentSearches.slice(0, 5);
      localStorage.setItem(storageName, JSON.stringify(recentSearches));
    }
  }
}
